export const COVID_LIST_SUCCESS = 'COVID_LIST_SUCCESS'
export const COVID_LIST_FAIL = 'COVID_LIST_FAIL'
